var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.viewSettings.usesNewKDiagramView)?_c('KDiagramView'):_c('LegacyKDiagram')}
var staticRenderFns = []

export { render, staticRenderFns }